module.exports = __webpack_public_path__ + "static/media/Inter-BoldItalic.96284e2a.woff2";